import React from 'react';
import Styled from 'styled-components';
import SadTelly from '../../images/sad-telly.png';

/*
	I coded this in the wrong order, for a 1080p screen, and so the media breaks
	go from a large base to smaller applications. Usually you want to start small.
*/
const imgMinWidth = 300;
const textMinWidth = 500;
const imgMargin = 32;
// we need wrap 1px *before* elements are too big, not exactly when they are too big
const mediumBreak = imgMinWidth + textMinWidth + imgMargin - 1;
// a little more than half
const smallBreak = mediumBreak - (textMinWidth * 0.7);
// hd screens
const largeBreak = 1450;

const centered = `
	display: flex;
	align-items: center;
	justify-content: center;
`;

const BackgroundGradient = Styled.div`
	position: fixed;
	width: 150%;
	height: 100%;
	top: -40%;
	left: -25%;
	background: #2e0505;
	opacity: 0.4;
	filter: blur(300px);
	transform: matrix(-1, 0, 0, 1, 0, 0);
	border-radius: 50%;
`;

const IncompatibleWrapper = Styled.div`
	${centered}
	position: relative;
	overflow: hidden;
	height: 100vh;
	width: 100vw;
	flex-wrap: wrap;
`;

const Telly404 = Styled.img`
	flex: 1;
	min-width: ${imgMinWidth}px;
	height: auto;
	margin-right: ${imgMargin}px;
	z-index: 1;
	max-width: 40%;
	
	@media (max-width: ${largeBreak}px) {
		max-width: 40%;
	}

	@media (max-width: ${mediumBreak}px) {
		align-self: end;
		max-width: 50%;
		margin: auto ${imgMargin}px 0 0;
	}
`;

const ErrWrapper = Styled.div`
	flex: 1;
	min-width: ${textMinWidth}px;
	z-index: 1;
	max-width: fit-content;
	
	@media (max-width: ${mediumBreak}px) {
		${centered}
		align-self: start;
		flex-direction: column;
		margin: 16px 0 auto 0;
	}
	
	@media (max-width: ${smallBreak}px) {
		min-width: 100%;
		margin: 16px 0 auto 0;
	}
`;

const ErrTitle = Styled.h1`
	font-weight: 700;
	white-space: nowrap;
	margin: 0;
	font-size: 56px;
	max-width: fit-content;

	@media (max-width: ${largeBreak}px) {
		font-size: 40px;
	}
	
	@media (max-width: ${mediumBreak}px) {
		font-size: 32px;
	}
	
	@media (max-width: ${smallBreak}px) {
		font-weight: 600;
		font-size: 24px;
	}
`;

const ErrSubTitle = Styled.p`
	font-size: 24px;
	font-weight: 500;
	white-space: nowrap;
	margin: 16 0;
	
	@media (max-width: ${largeBreak}px) {
		font-size: 20px;
		font-weight: 500;
	}

	@media (max-width: ${mediumBreak}px) {
		text-align: center;
		font-size: 16px;
		font-weight: 400;
		white-space: normal;
	}
	
	// force wrap text on extra-small screens
	@media (max-width: ${smallBreak - 150}px) {
		font-size: 16px;
		max-width: 60%;
	}
`;

const ButtonWrapper = Styled.div`
	display: flex;
	gap: 8px;

	@media (max-width: ${smallBreak}px) {
		flex-direction: column;
	}

	a {
		${centered}
		flex: 1;
		line-height: 0;
		color: white;
		border-radius: 8px;
		white-space: nowrap;
		min-width: 200px;
		font-size: 20px;
		font-weight: 600;
		max-width: fit-content;
		padding: 16px 48px;
		
		@media (max-width: ${largeBreak}px) {
			padding: 16px 24px;
			font-size: 18px;
			font-weight: 500;
		}
		
		@media (max-width: ${mediumBreak}px) {
			font-size: 16px;
		}

		@media (max-width: ${smallBreak}px) {
			font-size: 12px;
			max-width: 100%;
		}
	}

	svg {
		min-height: 28px;
		min-width: 32px;
		margin-right: 8px;

		@media (max-width: ${largeBreak}px) {
			min-height: 20px;
			min-width: 20px;
		}
	}
`;

const Apple = Styled.a`background: linear-gradient(92.49deg, #16ACE3 0.16%, #1D69DB 100.16%);`;
const Edge = Styled.a`background: linear-gradient(95.59deg, #0192CC 0%, #07B2C0 54.17%, #2AC77E 100%);`;
const Chrome = Styled.a`background: linear-gradient(88.46deg, #BC473A 0%, #C49619 32.55%, #4C8F49 66.92%, #5392F1 100%);`;

const Logos = {
	Chrome: <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fillRule="evenodd" clipRule="evenodd" d="M5.04447 9.2222L2.18175 4.26482C4.01431 1.97088 6.83463 0.499634 9.99925 0.499634C13.6608 0.499634 16.8608 2.46729 18.6033 5.40238H10.443C10.2964 5.3902 10.148 5.38245 9.99781 5.38245C7.61788 5.38245 5.61181 7.01645 5.04303 9.22145L5.04453 9.2222H5.04447ZM13.5795 6.84851H19.3113C19.7549 7.97982 20 9.21226 20 10.5008C20 15.9859 15.5834 20.4388 10.1133 20.5L14.2033 13.4159C14.7798 12.588 15.1172 11.5833 15.1172 10.5008C15.1172 9.07232 14.5285 7.77826 13.5795 6.84851H13.5795ZM6.36694 10.5008C6.36694 8.49767 7.99688 6.86845 9.99925 6.86845C12.002 6.86845 13.6319 8.49842 13.6319 10.5008C13.6319 12.5035 12.002 14.1334 9.99925 14.1334C7.99688 14.1334 6.36694 12.5035 6.36694 10.5008ZM11.3704 15.4308L8.50806 20.39C3.69281 19.67 0 15.5161 0 10.5008C0 8.71988 0.466187 7.04748 1.28262 5.59838L5.36522 12.6696C6.18278 14.4095 7.95297 15.6187 9.99887 15.6187C10.4736 15.6187 10.9323 15.5534 11.3701 15.4323L11.3705 15.4308H11.3704Z" fill="white" />
	</svg>,
	Apple: <svg width="19" height="22" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M15.5341 11.6996C15.509 8.92019 17.8227 7.56802 17.9285 7.50507C16.6181 5.60531 14.5871 5.34574 13.8734 5.32504C12.1676 5.14653 10.5129 6.34003 9.644 6.34003C8.75771 6.34003 7.41959 5.34229 5.97741 5.37161C4.12157 5.40007 2.38541 6.46852 1.43321 8.12769C-0.531903 11.5107 0.933691 16.4822 2.81641 19.2167C3.75821 20.5559 4.85871 22.0513 6.29915 21.9987C7.70837 21.9409 8.23478 21.1053 9.93538 21.1053C11.6204 21.1053 12.1147 21.9987 13.5838 21.965C15.0962 21.9409 16.0484 20.6197 16.9572 19.2684C18.0456 17.7335 18.4827 16.2217 18.5 16.1441C18.4644 16.1321 15.5627 15.0308 15.5341 11.6996Z" fill="white" />
		<path d="M12.7591 3.52616C13.517 2.58361 14.0356 1.30129 13.8916 0C12.7946 0.0482918 11.4227 0.75456 10.6327 1.67642C9.93368 2.48875 9.30928 3.82023 9.47058 5.07237C10.7029 5.16377 11.9682 4.45406 12.7591 3.52616Z" fill="white" />
	</svg>,
	Edge: <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M9.85999 13.8702C9.16999 13.1002 8.69999 12.1802 8.54999 11.1502C8.24999 11.6102 7.99999 12.1102 7.81999 12.6502C6.89999 15.4002 8.49999 18.8302 11.22 19.8302C13.56 20.6102 16.19 19.2202 17.92 17.7002C18.18 17.3502 20.23 15.5402 19.21 15.3402C16.19 16.8902 12.19 16.4502 9.85999 13.8702ZM10.46 8.06017C11.5 8.05017 10.5 7.63017 10.07 7.31017C9.02999 6.74017 7.80999 6.46017 6.62999 6.46017C2.77999 6.50017 -0.00500834 8.91017 1.29999 12.9002C2.23999 16.7802 5.60999 19.9002 9.58999 20.4002C7.53999 19.1102 6.29999 16.6902 6.29999 14.2802C6.37999 11.7502 7.93999 8.78017 10.46 8.06017ZM1.77999 6.74017C4.81999 4.50017 9.65999 4.68017 12.28 7.50017C13.3 8.61017 14 10.5002 13.07 11.8702C11.33 13.7502 16.15 14.0002 17.18 13.7202C20.92 13.0002 21.91 8.65017 20.13 5.65017C18.43 2.25017 14.66 0.470175 10.96 0.500175C6.89999 0.430175 3.24999 3.00017 1.77999 6.74017Z" fill="white" />
	</svg>,
};

interface UnsupportedProps {
	android?: true;
	ios?: true;
}

const UnsupportedSplashPage = (
	{ ios, android }: UnsupportedProps,
) => <IncompatibleWrapper>
	<Telly404 alt={'Telly 404 image'} src={SadTelly} />
	<ErrWrapper>
		<ErrTitle>
			{(ios || android) ? 'Device' : 'Browser'} Incompatible
		</ErrTitle>
		<ErrSubTitle>
			{ios
				? 'Download Greenroom on the App Store:'
				: 'Greenroom supports the following browsers:'
			}
		</ErrSubTitle>
		<ButtonWrapper>
			{ios
				? <Apple href="https://apps.apple.com/us/app/brandlive-greenroom/id1526479905" target='_blank'>
					{Logos.Apple} App Store
				</Apple>
				: <>
					<Chrome href="https://google.com/chrome" target='_blank'>
						{Logos.Chrome} Google Chrome
					</Chrome>
					<Edge href="https://www.microsoft.com/en-us/edge" target='_blank'>
						{Logos.Edge} Microsoft Edge
					</Edge>
				</>
			}
		</ButtonWrapper>
	</ErrWrapper>
	<BackgroundGradient />
</IncompatibleWrapper>;

export default UnsupportedSplashPage;
